module.exports = __webpack_public_path__ + "static/media/layout.6c96cbd0.png";